import type { User } from "@/api/auth";

export function isSuperAdmin(user: User | null): boolean {
  return user?.superAdmin ?? false;
}

export function canAccessAdminResources(user: User | null): boolean {
  return user?.admin || (user?.roles?.includes("admin-resources") ?? false);
}
